import * as Sentry from '@sentry/react';
import { useLocation, useNavigationType } from 'react-router-dom'; // Import react-router-dom hooks
import { createRoutesFromChildren, matchRoutes } from 'react-router';
import React from 'react';

export function initSentry(): void {
  Sentry.init({
    // NOTE: we should create this env variable in remote repo.
    dsn: process.env.REACT_APP_SENTRY_DSN,

    // NOTE: we should create this env variable in remote repo.
    environment: process.env.REACT_APP_ENV,

    // This sets the sampling rate for transaction monitoring.
    // A value of 1 means that 100% of transactions will be captured for performance monitoring.
    // You can adjust this value based on your needs and the volume of traffic to your application.
    tracesSampleRate: 1.0,

    // This sets the sample rate for capturing session replays when an error occurs.
    // A value of 1.0 means that 100% of sessions with an error will be captured for replay.
    replaysOnErrorSampleRate: 1.0,

    // When set to true, this option prints useful information to the console during Sentry setup.
    // It can be helpful for debugging any configuration issues.
    debug: false,

    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],

    ignoreErrors: [
      'CanceledError', // for canceled api error
    ],
  });
}

export const ErrorBoundary = Sentry.ErrorBoundary;
